// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"480":"f882e4c0","701":"81240698","785":"c15f281e"}[chunkId] + ".css";
};